const WorkoutCategory = require('../workoutCategory');
const WorkoutItem = require('../workoutItem');
const rules = require('../rules/rules');
const workouts = require('../workoutslib/workoutsLib');







module.exports = {
  categories: [ workouts.enduranceF, workouts.enduranceActive, workouts.enduranceSprint, workouts.enduranceForce,
     workouts.tempoForce, workouts.tempo, workouts.pma, workouts.sst
  ],

  rules: [

    rules.frequencyRule('enduranceF', 'MIN', 1, 'REQUIRED'),
    rules.frequencyRule('enduranceF', 'MIN', 2, 'MEDIUM'),
    rules.frequencyRule('enduranceActive', 'MIN', 1, 'HIGH'),
    rules.frequencyRule('enduranceActive', 'MIN', 2, 'LOW'),
    rules.frequencyRule('enduranceSprint', 'MIN', 1, 'VERYHIGH'),
    rules.frequencyRule('enduranceSprint', 'MAX', 1, 'REQUIRED'),

    rules.frequencyRule(['enduranceF', 'enduranceActive', 'enduranceSprint'], 'MIN', 2, 'HIGH'),
    rules.frequencyRule(['enduranceF', 'enduranceActive', 'enduranceSprint'], 'MAX', 5, 'HIGH'),


    rules.placementRule('enduranceSprint', 'AFTER', ['enduranceForce', 'enduranceActive', 'enduranceF'], 'HIGH'),
    rules.placementRule('enduranceForce', 'BEFORE', ['enduranceActive', 'enduranceF'], 'HIGH'),
    rules.placementRule('tempo', 'BEFORE', ['enduranceActive', 'enduranceF','enduranceSprint'], 'HIGH'),
    rules.placementRule('tempoForce', 'BEFORE', ['enduranceF', 'enduranceActive'], 'HIGH'),
    rules.placementRule('tempo', 'AFTER', 'tempoForce', '!VERYHIGH', 2),
    rules.placementRule('tempoForce', 'AFTER', 'tempo', '!VERYHIGH', 2),
    rules.placementRule('PMA', 'BEFORE', ['enduranceActive', 'enduranceF'], 'HIGH'),
    rules.placementRule('PMA', 'BEFORE', 'opener', 'FORBIDDEN'),
    rules.placementRule('tempo', 'BEFORE', 'PMA', '!VERYHIGH', 2),
    rules.placementRule('tempoForce', 'BEFORE', 'PMA', '!VERYHIGH', 2),
    rules.placementRule('PMA', 'BEFORE', 'objectiveC', 'FORBIDDEN'),


    rules.trainingRideCategory(['hard', 'very_hard'], 'PMA', 'REQUIRED'),
    rules.trainingRideCategory('medium', ['tempo', 'tempoForce'], 'REQUIRED'),
    rules.trainingRideCategory('medium', 'tempo', 'LOW'),
    rules.trainingRideCategory('endurance', ['enduranceSprint', 'enduranceForce', 'enduranceActive', 'enduranceF'], 'REQUIRED'),
    rules.trainingRideCategory('easy', 'enduranceF', 'REQUIRED'),

    rules.ifObjectivesNumber('>=', 1, 'ABC', rules.frequencyRule('tempoForce', 'MAX', 0, 'REQUIRED', 10)),
    rules.ifObjectivesNumber('>=', 2, 'ABC', rules.frequencyRule('PMA', 'MAX', 0, 'REQUIRED', 10)),
    rules.ifObjectivesNumber('>=', 3, 'ABC', rules.frequencyRule('tempo', 'MAX', 0, 'REQUIRED', 10)),





    //Semaine 1
    rules.forWeek(1, [
      rules.weekHoursTargetRule('TARGET', 97, '%', 'VERYHIGH', 5),

      rules.frequencyRule('enduranceF', 'MIN', 2, 'HIGH'),
      rules.frequencyRule('enduranceActive', 'MIN', 2, 'MEDIUM'),
      rules.frequencyRule('tempo', 'MAX', 0, 'REQUIRED'),
      rules.frequencyRule('tempoForce', 'MAX', 0, 'REQUIRED'),
      rules.frequencyRule('PMA', 'MAX', 0, 'REQUIRED'),

      rules.longestWorkoutDurationTargetRule('TARGET', 1, 15, '%', 'HIGH'),
    ]),

    //Semaine 2
    rules.forWeek(2, [
      rules.weekHoursTargetRule('TARGET', 112, '%', 'VERYHIGH', 5),

      rules.frequencyRule('tempo', 'EQUAL', 1, 'REQUIRED'),
      rules.frequencyRule('enduranceForce', 'MIN', 1, 'VERYHIGH'),
      rules.frequencyRule('tempoForce', 'EQUAL', 0, 'REQUIRED'),
      rules.frequencyRule('PMA', 'MAX', 0, 'REQUIRED'),

      rules.frequencyRule('sst', 'MAX', 2, 'REQUIRED'),

      rules.categoryLevelRule('tempo', 0, 'REQUIRED'),


      rules.longestWorkoutDurationTargetRule('TARGET', 1, 20, '%', 'HIGH'),

      rules.weekZoneTargetRule('z3', 'TARGET', 15, '%', 'MEDIUM'),
    ]),

    //Semaine 3
    rules.forWeek(3, [
      rules.weekHoursTargetRule('TARGET', 127, '%', 'VERYHIGH', 5),

      rules.frequencyRule('tempo', 'EQUAL', 1, 'REQUIRED'),
      rules.frequencyRule('tempoForce', 'EQUAL', 1, 'REQUIRED'),

      rules.frequencyRule('PMA', 'MIN', 1, 'VERYHIGH'),
      rules.frequencyRule('PMA', 'MAX', 1, 'REQUIRED'),

      rules.frequencyRule('sst', 'MAX', 0, 'REQUIRED'),


      rules.categoryLevelRule('tempo', 0.5, 'REQUIRED'),
      rules.categoryLevelRule('tempoForce', 0, 'REQUIRED'),
      rules.categoryLevelRule('PMA', 0, 'REQUIRED'),


      rules.longestWorkoutDurationTargetRule('TARGET', 1, 20, '%', 'HIGH'),

      rules.weekZoneTargetRule('z3', 'TARGET', 15, '%', 'MEDIUM'),
    ]),

  ],
};
